<div class="container p-3">
    <div class="row justify-content-md-center">
        <div class="col col-md-auto">
            <p class="col col-md-auto">Coming soon...</p>
        </div>
    </div>
</div>
